import type { ContactInquiry } from '../../../model/contact/contact';

export type SubmitContactRequest = ContactInquiry;

export interface SubmitContactResponse {
  ticketId: number;
}
